import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@rabex-kit/rabex-ui';
import { ContentSkeleton } from '../RouteFallback/PageSkeleton';
import { chromeForPath, variantForPath } from '../RouteFallback';

/*
 * Kept apart from AppShell on purpose: PrivateRoute is in the entry chunk and
 * needs these two, while AppShell pulls in the whole layout and stays lazy.
 */
const InShellContext = createContext(false);

export const ShellProvider = InShellContext.Provider;

/** True under AppShell, where the frame is already real and only content waits. */
export const useInShell = () => useContext(InShellContext);

/** The page's body while its code loads, inside the real frame. */
export const ContentFallback = () => {
  const { pathname } = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <ContentSkeleton
      layout={isMobile ? 'mobile' : 'desktop'}
      variant={variantForPath(pathname)}
      chrome={chromeForPath(pathname)}
    />
  );
};
